import { IconLoader } from 'common/IconLoader';

// Enums
export const RULE_COMPARISON_MODE = {
  CALC: 'calc',
  CONST: 'const'
};

export const RULE_FILTERS_MODE = {
  SOURCE: 'source',
  TARGET: 'target'
};

export const MODAL_FORM_MODE = {
  CREATION: 0,
  UPDATION: 1
};

export const RULE_AGGREGATION_OPTIONS = [
  { label: 'Maximum', value: 'maximum' },
  { label: 'Minimum', value: 'minimum' },
  { label: 'Average', value: 'average' },
  { label: 'Std Deviation', value: 'standard_deviation' }
];

export const RULE_AGGREGATION_LEVEL_OPTIONS = [
  { label: 'Device', value: 'device' },
  { label: 'List', value: 'list' }
];

export const ALERT_NOTIFICATION_FIELDS_ERRORS = {
  INVALID_FORMAT: 'Invalid email or phone number format',
  DUPLICATED_RECIEVER: 'This contact is already added'
};

export const RULE_TIME_OPTIONS_VALUES = {
  CURRENT: 'current',
  LAST_24_HOURS: '1d',
  LAST_2_DAYS: '2d',
  LAST_WEEK: '7d',
  LAST_MONTH: '1M',
  CUSTOM_RANGE: 'fix'
};

export const RULE_TIME_OPTIONS = [
  { label: 'Current', value: RULE_TIME_OPTIONS_VALUES.CURRENT },
  { label: 'Last 24 hours', value: RULE_TIME_OPTIONS_VALUES.LAST_24_HOURS },
  { label: 'Last 2 days', value: RULE_TIME_OPTIONS_VALUES.LAST_2_DAYS },
  { label: 'Last week', value: RULE_TIME_OPTIONS_VALUES.LAST_WEEK },
  { label: 'Last month', value: RULE_TIME_OPTIONS_VALUES.LAST_MONTH },
  { label: 'Custom Range', value: RULE_TIME_OPTIONS_VALUES.CUSTOM_RANGE }
];

export const RULE_OPERATORS = {
  more_or_equal: { label: IconLoader.icon_more_and_equal_operator, value: '≥' },
  more: { label: IconLoader.icon_more_operator, value: '>' },
  equal: { label: IconLoader.icon_equal_operator, value: '=' },
  not_equal: { label: IconLoader.icon_not_equal_operator, value: '≠' },
  less: { label: IconLoader.icon_less_operator, value: '<' },
  less_or_equal: { label: IconLoader.icon_less_or_equal_operator, value: '≤' }
};

export const RULE_METRIC_OPERATOR_DEPENDENCIES = {
  integer: ['more_or_equal', 'more', 'equal', 'not_equal', 'less', 'less_or_equal'],
  long: ['more_or_equal', 'more', 'equal', 'not_equal', 'less', 'less_or_equal'],
  double: ['more_or_equal', 'more', 'equal', 'not_equal', 'less', 'less_or_equal'],
  string: ['equal', 'not_equal'],
  boolean: ['equal', 'not_equal'],
  date: ['more_or_equal', 'equal', 'not_equal', 'less_or_equal'],
  datetime: ['more_or_equal', 'less_or_equal']
};

export const RULE_COMPARISON_MODE_OPTIONS = [
  { label: 'Constant', value: RULE_COMPARISON_MODE.CONST },
  { label: 'Devices/Time/Aggregation', value: RULE_COMPARISON_MODE.CALC }
];

export const DELTA_TOOLTIP_MESSAGE = 'Delta value is added to the right side before comparing to the left side';

// Alert history_(start)
export const ALERT_HISTORY_TYPE_STATUSES = {
  NEW_CONTACT: 'new_contact',
  UNAVAILABLE_DEVICE: 'unavailable_device',
  RULE_TRIGGERING: 'rule_triggering',
  RULE_CHANGE: 'rule_change',
  POLYGON_REMOVAL: 'polygon_removal',
  ALERT_ACTIVATED: 'alert_activated',
  ALERT_DEACTIVATED: 'alert_deactivated',
  EMPTY_DATA: 'empty_data',
  EMPTY_FILTER: 'empty_filter',
  ERROR: 'error'
};

export const nonNotificationTypes = [
  ALERT_HISTORY_TYPE_STATUSES.EMPTY_DATA,
  ALERT_HISTORY_TYPE_STATUSES.EMPTY_FILTER,
  ALERT_HISTORY_TYPE_STATUSES.ERROR
];

export const MIN_SEARCH_VALUE_LENGTH = 3;
export const ALERT_HISTORY_REQUEST_LIMIT = 100;
export const ALERT_HISTORY_EMPTY = 'No event';
// Alert history_(end)

export const defaultConditionData = {
  comparationType: '≥',
  [RULE_FILTERS_MODE.SOURCE]: {
    type: RULE_COMPARISON_MODE.CALC,
    metricId: null,
    geoFilter: null,
    aggregationType: null,
    aggregationLevel: 'device',
    time: { offset: RULE_TIME_OPTIONS[0].value, startDate: null, endDate: null }
  },
  [RULE_FILTERS_MODE.TARGET]: {
    type: RULE_COMPARISON_MODE.CONST,
    metricId: null,
    value: '',
    delta: '',
    geoFilter: null,
    aggregationType: 'maximum',
    aggregationLevel: 'list',
    time: null
  }
};

export const ALERT_DELETE_TEXT = 'Do you want to delete the alert?';
export const ALERT_RULES_DELETE_TEXT_TYPE_NO_CONNECTED_ALERTS = 'Do you want to delete the alert rule?';
export const ALERT_RULES_DELETE_TEXT_TYPE_CONNECTED_ALERTS =
  'Your rule is connected to the alert(s). Do you want to disconnect and delete the alert rule?';

export const MAX_PHONE_US_FORMAT_LENGTH = 11;
export const PHONE_PATTERN = 'x-xxx-xxx-xxxx';

export const TIME_MEASURES = {
  HOUR: 'hour',
  MINUTE: 'minute'
};

// Alert Rules error messages
export const ALERT_RULES_ERRORS = {
  METRIC_ID: 'Metric cannot be empty',
  COMPARATION_TYPE: 'Wrong operator format',
  AGGREGATION_TYPE: 'Aggregation cannot be empty',
  DELTA: 'Wrong delta type'
};
